import PropTypes from 'prop-types';
import React from 'react';

import { t } from '../../../../../modules/infra/i18n';
import RoleAwareLink from '../../../../common/RoleAwareLink';
import SimpleHeader from '../../../../main/headers/simpleHeader';

const SharedFormHeader = (props) => (
  <SimpleHeader heading={t('products:purchase_order.create_heading')}>
    <div className="o-flexbox o-flexbox--content-align-center u-pr">
      <button
        type="button"
        className="c-btn c-btn--white c-btn--medium u-mr u-width-85"
        disabled={props.disabled}
        onClick={props.goBack}
        display-if={props.canGoBack}
      >
        {t('products:purchase_order.back_button')}
      </button>
      <RoleAwareLink to={props.disabled ? '' : '/products'}>
        <button type="button" className="c-btn c-btn--white c-btn--medium u-mr u-width-85" disabled={props.disabled}>
          {t('products:purchase_order.cancel_button')}
        </button>
      </RoleAwareLink>
      <button type="submit" className="c-btn c-btn--medium u-width-85" disabled={props.disabled} form="po-form">
        {props.isLastStep ? t('products:purchase_order.save_button') : t('products:purchase_order.continue_button')}
      </button>
    </div>
  </SimpleHeader>
);

SharedFormHeader.propTypes = {
  disabled: PropTypes.bool.isRequired,
  goBack: PropTypes.func.isRequired,
  canGoBack: PropTypes.bool.isRequired,
  isLastStep: PropTypes.bool.isRequired,
};

export default SharedFormHeader;
